var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGuarantee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2628 11.132C29.3388 9.78529 28.3934 8.54929 27.0614 8.32929C21.5268 7.41863 21.9521 3.16663 16.0001 3.16663C10.0481 3.16663 10.4734 7.41863 4.93876 8.32929C3.60676 8.54796 2.66143 9.78396 2.73743 11.132C3.3081 21.3053 7.37876 26.1386 16.0001 29.8333C24.6214 26.1386 28.6921 21.3053 29.2628 11.132Z",
    fill: "#C0D0EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 21.8333C14.3253 21.8333 13.984 21.7026 13.724 21.4426L9.72401 17.4426C9.20267 16.9213 9.20267 16.0786 9.72401 15.5573C10.2453 15.036 11.088 15.036 11.6093 15.5573L14.6667 18.6146L20.3907 12.8906C20.912 12.3693 21.7547 12.3693 22.276 12.8906C22.7973 13.412 22.7973 14.2546 22.276 14.776L15.6093 21.4426C15.3493 21.7026 15.008 21.8333 14.6667 21.8333Z",
    fill: "#4671F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGuarantee);
export default __webpack_public_path__ + "static/media/ic-guarantee.78a32b1d54343fd0ce1b09252274975a.svg";
export { ForwardRef as ReactComponent };